
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceShadeSelectionVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <g clipPath = 'url(#clip0_1843_14957)'>
        <path fill = 'white' d = 'M10 18.5C5.592 18.5 2 14.908 2 10.5C2 6.092 5.592 2.5 10 2.5C14.408 2.5 18 5.732 18 9.7C18 12.348 15.848 14.5 13.2 14.5H11.784C11.56 14.5 11.384 14.676 11.384 14.9C11.384 14.996 11.424 15.084 11.488 15.164C11.816 15.54 12 16.012 12 16.5C12 17.604 11.104 18.5 10 18.5ZM10 4.1C6.472 4.1 3.6 6.972 3.6 10.5C3.6 14.028 6.472 16.9 10 16.9C10.224 16.9 10.4 16.724 10.4 16.5C10.4 16.372 10.336 16.276 10.288 16.22C9.96 15.852 9.784 15.38 9.784 14.9C9.784 13.796 10.68 12.9 11.784 12.9H13.2C14.968 12.9 16.4 11.468 16.4 9.7C16.4 6.612 13.528 4.1 10 4.1Z' />
        <path fill = 'white' d = 'M6.33301 10.6665C6.88529 10.6665 7.33301 10.2188 7.33301 9.6665C7.33301 9.11422 6.88529 8.6665 6.33301 8.6665C5.78072 8.6665 5.33301 9.11422 5.33301 9.6665C5.33301 10.2188 5.78072 10.6665 6.33301 10.6665Z' />
        <path fill = 'white' d = 'M8 7.5C8.55228 7.5 9 7.05228 9 6.5C9 5.94772 8.55228 5.5 8 5.5C7.44772 5.5 7 5.94772 7 6.5C7 7.05228 7.44772 7.5 8 7.5Z' />
        <path fill = 'white' d = 'M12 7.5C12.5523 7.5 13 7.05228 13 6.5C13 5.94772 12.5523 5.5 12 5.5C11.4477 5.5 11 5.94772 11 6.5C11 7.05228 11.4477 7.5 12 7.5Z' />
        <path fill = 'white' d = 'M14.333 10.6665C14.8853 10.6665 15.333 10.2188 15.333 9.6665C15.333 9.11422 14.8853 8.6665 14.333 8.6665C13.7807 8.6665 13.333 9.11422 13.333 9.6665C13.333 10.2188 13.7807 10.6665 14.333 10.6665Z' />
      </g>
      <defs>
        <clipPath id = 'clip0_1843_14957'>
          <rect width = '20' height = '20' fill = 'white'/>
        </clipPath>
      </defs>
    </svg>

  );
};
